/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const ANIMATION = 'animation';
const BACKGROUND_BLUR = 'backgroundBlur';
const BORDER_RADIUS = 'borderRadius';
const BORDER = 'borderStyle';
const CAPTIONS = 'captions';
const EFFECTS = 'effects';
const STYLE_PRESETS = 'stylePresets';
const COLOR_PRESETS = 'colorPresets';
const FILTER = 'filter';
const IMAGE_ACCESSIBILITY = 'imageAccessibility';
const LAYER_STYLE = 'layerStyle';
const LINK = 'link';
const LOTTIE_PARAMETERS = 'lottieParameters';
const LOTTIE_PLAYBACK = 'lottiePlayback';
const LUT_FILTER = 'lutFilter';
const PAGE_ATTACHMENT = 'pageAttachment';
const PAGE_BACKGROUND = 'pageBackground';
const PAGE_BACKGROUND_AUDIO = 'pageBackgroundAudio';
const SIZE_POSITION = 'sizePosition';
const SHAPE_STYLE = 'shapeStyle';
const TEXT_BORDER = 'textBorder';
const TEXT_BOX = 'textBox';
const TEXT_PINNING = 'textPinning';
const TEXT_STYLE = 'textStyle';
const VIDEO_OPTIONS = 'videoOptions';
const VIDEO_ACCESSIBILITY = 'videoAccessibility';
const ELEMENT_ALIGNMENT = 'elementAlignment';
const AUTOMATION_KEY = 'automationKey';

const PanelTypes = {
  ELEMENT_ALIGNMENT,
  PAGE_BACKGROUND,
  PAGE_ATTACHMENT,
  PAGE_BACKGROUND_AUDIO,
  SIZE_POSITION,
  COLOR_PRESETS,
  STYLE_PRESETS,
  TEXT_STYLE,
  TEXT_BORDER,
  TEXT_BOX,
  TEXT_PINNING,
  EFFECTS,
  LAYER_STYLE,
  BACKGROUND_BLUR,
  FILTER,
  SHAPE_STYLE,
  BORDER,
  BORDER_RADIUS,
  LOTTIE_PARAMETERS,
  LOTTIE_PLAYBACK,
  LUT_FILTER,
  VIDEO_OPTIONS,
  ANIMATION,
  CAPTIONS,
  LINK,
  IMAGE_ACCESSIBILITY,
  VIDEO_ACCESSIBILITY,
  AUTOMATION_KEY,
};

export default PanelTypes;
